import { Accordion, AccordionDetails, AccordionSummary, Box, TextField, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { getApplicationDisplayFields, getStartupDetail } from '../../DashBoard/Api';
import { IInputField, IStartupDetails, ITeamDeatils } from '../../Interfaces/IApplicationDetails';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { makeStyles } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';
import Loaders from '../../../../GlobalComponents/KenLoader';
export interface IApplicationProps {
  id: string;
  data: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  detailsHeader: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: '#0F0E1F',
    borderBottom: '1px solid red',
    padding: '10px 0px',
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
    },  
  
  },
  labelText: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#8C8E94',
    '@media (max-width: 1440px)': {
      fontSize: '10px !important',
    },  
  },
  input: {
    fontSize: '14px',
    fontWeight: '400',
    color: 'rgba(0, 0,  0, 0.8)',
    borderRadius: '4px',
    [theme.breakpoints.down('md')]: {
      borderRadius: '8px !important',
    },
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
    },  
  },
}));

const ApplicationDetailsField: React.FunctionComponent<any> = (props) => {
  const classes = useStyles();
  return (
    <Box component={'div'} className='w-100'>
      <Typography className={classes.labelText}>{props?.label}</Typography>
      <TextField
        value={props?.value}
        InputProps={{ readOnly: true }}
        variant="standard"
        size="small"
        fullWidth
        inputProps={{ className: classes.input }}
      />
    </Box>
  );
};

const ApplicationDetailsFields: React.FunctionComponent<any> = (props) => {
  return (
    <Box component={'div'} className='w-100'>
      <Typography style={{
        fontSize: 4, fontWeight: '500 !important',
        color: '#8C8E94'
      }}>{props?.label}</Typography>
      <Typography style={{ fontSize: 5, fontWeight: '500 !important' }}
      >{props?.value}</Typography>
    </Box>
  );
};

const ApplicationDetails: React.FunctionComponent<IApplicationProps> = (props) => {
  const { id, data } = props;
  const isMobile = useMediaQuery('(max-width:600px)');
  const isMaxScreen = useMediaQuery('(max-width:1440px)');
  const classes = useStyles();

  const [selectedFields, setSelectedFields] = useState<Array<IInputField>>([]);
  const [ApplicationDetails, setApplicationDetails] = useState<IStartupDetails | undefined>();
  const [TeamDetails, setTeamDetails] = useState<ITeamDeatils[] | undefined>();
  const [displayFields, setDisplayFields] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const HEADER_FIELDS = ['Sector__c', 'Startup_Website_URL__c', 'Elevator_Pitch__c', 'Location__c'];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getApplicationDisplayFields();
        setDisplayFields(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          setIsLoading(true);
          const response: AxiosResponse = await getStartupDetail(id);
          const dataCustomized: any = response?.data?.data.application;
          const TeamMembers = (response?.data?.data.teamMembers || []).map((item: ITeamDeatils) => ({
            Application1__c: item?.Application1__c,
            Id: item?.Id,
            LastName: item?.LastName,
            Role__c: item?.Role__c,
          }));

          const updatedApplicationForms: any = displayFields.map((field) => ({
            label: getFieldName(field),
            name: field,
            value: dataCustomized?.[field] || '',
            grid: { lg: 6, md: 6, sm: 12 },
            featureEnable: true,
            informationEnable: !HEADER_FIELDS.includes(field),
          }));

          setSelectedFields(updatedApplicationForms);
          setApplicationDetails(dataCustomized);
          setTeamDetails(TeamMembers);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [id, displayFields]);

  function getFieldName(fieldName: string): string {
    fieldName = fieldName.replace(/__c$/, '');
    return fieldName.replace(/_/g, ' ');
  }

  return (
    <Box component={'div'} className='w-100' padding={isMobile ? "0px" : '0px 20px'}>
      {isLoading && <Loaders />}
      {isMobile ? (
        <Box component={'div'} padding={isMobile ? "12px" : '20px 24px'} className='w-100' height={isMaxScreen ? '350px' : '480px'} overflow={'auto'} border={'1px solid #E6E6E6'}>
          <Box component={'div'} className="d-flex flex-column gap-3">
            <Box component={'div'} borderBottom={'0.5px solid rgba(0, 0, 0, 0.5)'}>
              <Typography className={classes.detailsHeader}>Details</Typography>
            </Box>
            <Box component={'div'} className="w-100 mt-4">
              <Grid container rowSpacing={2} columnSpacing={isMobile ? 0 : 5} width={"100%"}>
                {selectedFields.map((items: any, index: number) => {
                  return (
                    <Grid item md={12} sm={12} xs={12} lg={6} key={index}>
                      <ApplicationDetailsField {...items} />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Box>
        </Box>
      ) : (
        <Grid container spacing={4}>
          <Grid item lg={2}>
            <Accordion sx={{ boxShadow: 'none' }}>
              <AccordionSummary
                expandIcon={<KeyboardArrowUpIcon sx={{ height: '16px' }} />}
                sx={{
                  borderBottom: '1px solid #E3E3E3',
                  '& .MuiAccordionSummary-content': {
                    margin: '0px',
                  },
                  '& .Mui-expanded': {
                    margin: '0px',
                  },
                }}
              >
                <Typography fontSize={isMaxScreen?'10px':"12px"} fontWeight={'500'} margin={'0px 0px'} color={'#000000'}>
                  Application details
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: '15px 10px' }}>
                <Box sx={{ border: '1px solid #0000001A', height: '210px', borderRadius: '8px', overflowY: 'auto', padding: '10px' }}>
                  {/* Compact Content */}
                  <Box component="div" borderBottom="0.5px solid red" padding="5px 0">
                    <Typography style={{ fontSize: 5, fontWeight: 600 }}>
                      Details
                    </Typography>
                  </Box>
                  <Box component="div" className="w-100 mt-2" style={{ fontSize: 3 }}>
                    <Grid container rowSpacing={1} columnSpacing={2} className="w-100" style={{ fontSize: 8 }}>
                      {selectedFields.map((items: any, index: number) => (
                        <Grid item xs={12} sm={6} key={index} style={{ fontSize: 8 }}>
                          <ApplicationDetailsFields {...items} style={{ fontSize: 8 }} />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item lg={10}>
            <Box component={'div'} padding={'20px 24px'} height={isMaxScreen ? '380px' : "400px"} overflow={'auto'} border={'1px solid #E6E6E6'} margin={'0px 100px'}>
              <Box component={'div'} className="d-flex flex-column gap-3">
                <Box component={'div'} borderBottom={'0.5px solid rgba(0, 0, 0, 0.5)'}>
                  <Typography className={classes.detailsHeader}>Details</Typography>
                </Box>
                <Box component={'div'} className="w-100 mt-4">
                  <Grid container rowSpacing={2} columnSpacing={5} className="w-100">
                    {selectedFields.map((items: any, index: number) => {
                      return (
                        <Grid item md={12} lg={6}>
                          <ApplicationDetailsField {...items} />
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ApplicationDetails;
